module.exports = __webpack_public_path__ + "img/sousakubento.39790020.png";